import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import UAParser from 'ua-parser-js';

const state = {
  ua: false,
  lang: '',
  isShowGnav: false,
  isShowLinks: false,
  links: {},
  note: {},
  urls: {
    ja: {
      weibo: '',
      wechat: '',
      fb: 'https://www.facebook.com/CITIZENwatch.jp/',
      tw: 'https://twitter.com/citizenwatchjp',
      yt: 'https://www.youtube.com/user/citizenwatchofficial',
      insta: 'https://www.instagram.com/citizenwatchjp/',
      citizen: 'https://citizen.jp/',
      citizen_tech: 'https://citizen.jp/core-technology/super-titanium/',
      globalnetwork: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      reuters_site: 'https://www.reuters.com/brandfeatures/jp/watch-tech-in-space-tech',
      manufacture: 'https://citizen.jp/manufacture/index.html',
      hakuto: 'https://www.reuters.com/brandfeatures/jp/watch-tech-in-space-tech/50-years-of-titanium-technology',
      lineup: '',
      page_top: '/titaniumtechnology50th/index.html',
      page_benefit: '/titaniumtechnology50th/benefit/index.html',
      page_technology: '/titaniumtechnology50th/technology/index.html',
      page_product: '/titaniumtechnology50th/product/index.html',
      page_product_feature: '/titaniumtechnology50th/product/feature/index.html',
      page_blue: '/titaniumtechnology50th/product-cosmicblue/index.html',
    },
    en: {
      weibo: '',
      wechat: '',
      fb: 'https://www.facebook.com/citizenwatchofficial/',
      tw: '',
      yt: 'https://www.youtube.com/user/citizenwatchglobal',
      insta: '',
      citizen: 'https://www.citizenwatch-global.com/',
      citizen_tech: 'https://www.citizenwatch-global.com/technologies/super-titanium/',
      globalnetwork: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      reuters_site: 'https://www.reuters.com/brandfeatures/watch-tech-in-space-tech',
      manufacture: 'https://www.citizenwatch-global.com/manufacture/',
      hakuto: 'https://www.reuters.com/brandfeatures/watch-tech-in-space-tech/50-years-of-titanium-technology',
      lineup: '',
      page_top: '/titaniumtechnology50th/index.html',
      page_benefit: '/titaniumtechnology50th/benefit/index.html',
      page_technology: '/titaniumtechnology50th/technology/index.html',
      page_product: '/titaniumtechnology50th/product/index.html',
      page_product_feature: '/titaniumtechnology50th/product/feature/index.html',
      page_blue: '/titaniumtechnology50th/products/index.html',
    },
    de: {
      weibo: '',
      wechat: '',
      fb: 'https://www.facebook.com/citizenwatchofficial/',
      tw: '',
      yt: 'https://www.youtube.com/user/citizenwatchglobal',
      insta: 'https://www.instagram.com/citizenwatchdeutschland/',
      citizen: 'https://www.citizenwatch-global.com/',
      citizen_tech: 'https://www.citizenwatch-global.com/technologies/super-titanium/',
      globalnetwork: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      reuters_site: 'https://www.reuters.com/brandfeatures/de/watch-tech-in-space-tech',
      manufacture: 'https://www.citizenwatch-global.com/manufacture/',
      hakuto: 'https://www.reuters.com/brandfeatures/de/watch-tech-in-space-tech/50-years-of-titanium-technology',
      lineup: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      page_top: '/titaniumtechnology50th/de/index.html',
      page_benefit: '/titaniumtechnology50th/de/benefit/index.html',
      page_technology: '/titaniumtechnology50th/de/technology/index.html',
      page_product: '/titaniumtechnology50th/de/product/index.html',
      page_product_feature: '/titaniumtechnology50th/de/product/feature/index.html',
      page_blue: '',
    },
    es: {
      weibo: '',
      wechat: '',
      fb: 'https://www.facebook.com/citizenespana/',
      tw: '',
      yt: 'https://www.youtube.com/user/citizenwatchglobal',
      insta: '',
      citizen: 'https://www.citizenwatch-global.com/',
      citizen_tech: 'https://www.citizenwatch-global.com/technologies/super-titanium/',
      globalnetwork: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      reuters_site: 'https://www.reuters.com/brandfeatures/es/watch-tech-in-space-tech',
      manufacture: 'https://www.citizenwatch-global.com/manufacture/',
      hakuto: 'https://www.reuters.com/brandfeatures/es/watch-tech-in-space-tech/50-years-of-titanium-technology',
      lineup: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      page_top: '/titaniumtechnology50th/es/index.html',
      page_benefit: '/titaniumtechnology50th/es/benefit/index.html',
      page_technology: '/titaniumtechnology50th/es/technology/index.html',
      page_product: '/titaniumtechnology50th/es/product/index.html',
      page_product_feature: '/titaniumtechnology50th/es/product/feature/index.html',
      page_blue: '',
    },
    fr: {
      weibo: '',
      wechat: '',
      fb: 'https://www.facebook.com/citizenwatchofficial/',
      tw: '',
      yt: 'https://www.youtube.com/user/citizenwatchglobal',
      insta: 'https://www.instagram.com/citizenwatchfr/',
      citizen: 'https://www.citizenwatch-global.com/',
      citizen_tech: 'https://www.citizenwatch-global.com/technologies/super-titanium/',
      globalnetwork: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      reuters_site: 'https://www.reuters.com/brandfeatures/fr/watch-tech-in-space-tech',
      manufacture: 'https://www.citizenwatch-global.com/manufacture/',
      hakuto: 'https://www.reuters.com/brandfeatures/fr/watch-tech-in-space-tech/50-years-of-titanium-technology',
      lineup: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      page_top: '/titaniumtechnology50th/fr/index.html',
      page_benefit: '/titaniumtechnology50th/fr/benefit/index.html',
      page_technology: '/titaniumtechnology50th/fr/technology/index.html',
      page_product: '/titaniumtechnology50th/fr/product/index.html',
      page_product_feature: '/titaniumtechnology50th/fr/product/feature/index.html',
      page_blue: '',
    },
    it: {
      weibo: '',
      wechat: '',
      fb: 'https://www.facebook.com/CitizenItalia/',
      tw: 'https://twitter.com/citizen_italia/',
      yt: 'https://www.youtube.com/user/citizenwatchglobal',
      insta: 'https://www.instagram.com/citizenitalia/',
      citizen: 'https://www.citizenwatch-global.com/',
      citizen_tech: 'https://www.citizenwatch-global.com/technologies/super-titanium/',
      globalnetwork: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      reuters_site: 'https://www.reuters.com/brandfeatures/it/watch-tech-in-space-tech',
      manufacture: 'https://www.citizenwatch-global.com/manufacture/',
      hakuto: 'https://www.reuters.com/brandfeatures/it/watch-tech-in-space-tech/50-years-of-titanium-technology',
      lineup: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      page_top: '/titaniumtechnology50th/it/index.html',
      page_benefit: '/titaniumtechnology50th/it/benefit/index.html',
      page_technology: '/titaniumtechnology50th/it/technology/index.html',
      page_product: '/titaniumtechnology50th/it/product/index.html',
      page_product_feature: '/titaniumtechnology50th/it/product/feature/index.html',
      page_blue: '',
    },
    "zh-cmn-Hant": {
      weibo: '',
      wechat: '',
      fb: 'https://www.facebook.com/citizenwatchofficial/',
      tw: '',
      yt: 'https://www.youtube.com/user/citizenwatchglobal',
      insta: 'https://www.instagram.com/citizenwatchhk/',
      citizen: 'https://www.citizenwatch-global.com/',
      citizen_tech: 'https://www.citizenwatch-global.com/technologies/super-titanium/',
      globalnetwork: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      reuters_site: 'https://www.reuters.com/brandfeatures/cn/watch-tech-in-space-tech',
      manufacture: 'https://www.citizenwatch-global.com/manufacture/',
      hakuto: 'https://www.reuters.com/brandfeatures/cn/watch-tech-in-space-tech/50-years-of-titanium-technology',
      lineup: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      page_top: '/titaniumtechnology50th/tc/index.html',
      page_benefit: '/titaniumtechnology50th/tc/benefit/index.html',
      page_technology: '/titaniumtechnology50th/tc/technology/index.html',
      page_product: '/titaniumtechnology50th/tc/product/index.html',
      page_product_feature: '/titaniumtechnology50th/tc/product/feature/index.html',
      page_blue: '',
    },
    "zh-cmn-Hans": {
      weibo: '',
      wechat: '',
      fb: '',
      tw: '',
      yt: 'https://www.youtube.com/user/citizenwatchglobal',
      insta: '',
      citizen: 'https://www.citizenwatch-global.com/',
      citizen_tech: 'https://www.citizenwatch-global.com/technologies/super-titanium/',
      globalnetwork: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      reuters_site: 'https://www.reuters.com/brandfeatures/cns/watch-tech-in-space-tech',
      manufacture: 'https://www.citizenwatch-global.com/manufacture/',
      hakuto: 'https://www.reuters.com/brandfeatures/cns/watch-tech-in-space-tech/50-years-of-titanium-technology',
      lineup: 'https://www.citizenwatch-global.com/index.html#globalNetwork',
      page_top: '/titaniumtechnology50th/sc/index.html',
      page_benefit: '/titaniumtechnology50th/sc/benefit/index.html',
      page_technology: '/titaniumtechnology50th/sc/technology/index.html',
      page_product: '/titaniumtechnology50th/sc/product/index.html',
      page_product_feature: '/titaniumtechnology50th/sc/product/feature/index.html',
      page_blue: '',
    },
    global: {
      weibo: '',
      wechat: '',
      fb: 'https://www.facebook.com/citizenwatchofficial/',
      tw: 'https://twitter.com/citizenwatchjp',
      yt: 'https://www.youtube.com/user/citizenwatchglobal',
      insta: 'https://www.instagram.com/citizenwatchjp/',
      citizen: 'https://www.citizenwatch-global.com/',
      citizen_tech: 'https://www.citizenwatch-global.com/technologies/super-titanium/'
    }
  },
  notes: {
    ja: {
      links: {
        title: '50th anniversary <br>of titanium technology',
        top: 'TOP PAGE',
        message: 'MESSAGE',
        about: 'ABOUT',
        features: 'FEATURES',
        special: 'SPECIAL',
        product: 'PRODUCT',
        contents: 'CONTENTS',
        language: 'LANGUAGE',
        links: 'LINKS',
        official: 'OFFICIAL',
        share: 'SHARE',
        topics: 'TOPICS',
        page_top: 'TOP PAGE',
        page_benefit: 'FEATURE #01',
        page_technology: 'FEATURE #02',
        page_product: 'PRODUCT',
        citizen_tech: 'シチズン テクノロジーサイト',
        citizen: 'CITIZEN公式サイト',
        citizen_global: 'CITIZENグローバルネットワーク',
        topics_reuters: 'スーパーチタニウム™と<br />宇宙への挑戦',
        topics_citizen_global: 'CITIZEN GLOBAL <br />NETWORK',
        topics_product1: '50周年記念フラッグシップモデル',
        topics_product2: 'SATELLITE WAVE GPS F950',
        topics_blue1: '50周年記念 限定モデル',
        topics_blue2: 'コズミックブルーコレクション',
        feature1: '強く、美しく、心地よく。',
        feature2: '進化が生んだ、<br />シチズンだけの技術',
        manufacture: 'マニュファクチュール',
        supertitanium: 'スーパーチタニウム™',
        reuters: 'スーパーチタニウム™と<br />宇宙への挑戦',
      },
      nav: {
        language: [
          {
            name: 'GLOBAL',
            link: 'ENGLISH'
          },
          {
            name: 'JAPANESE',
            link: '日本語'
          },
          {
            name: 'TRADITIONAL <br class="u-none-b--sp">CHINESE',
            link: '繁體中文'
          },
          {
            name: 'SIMPLIFIED <br class="u-none-b--sp">CHINESE',
            link: '简体中文'
          },
          {
            name: 'GERMAN',
            link: 'DEUTSCH'
          },
          {
            name: 'ITALIAN',
            link: 'ITALIANO'
          },
          {
            name: 'SPANISH',
            link: 'ESPAÑOL'
          },
          {
            name: 'FRENCH',
            link: 'FRANÇAIS'
          }
        ]
      }
    },
    de: {
      links: {
        title: '50th anniversary of <br />titanium technology',
        top: 'TOP PAGE',
        message: 'MESSAGE',
        about: 'ABOUT',
        features: 'FEATURES',
        special: 'SPECIAL',
        product: 'PRODUCT',
        contents: 'CONTENTS',
        language: 'LANGUAGE',
        official: 'OFFICIAL',
        share: 'SHARE',
        topics: 'TOPICS',
        page_top: 'TOP PAGE',
        page_benefit: 'FEATURE #01',
        page_technology: 'FEATURE #02',
        page_product: 'PRODUCT',
        citizen_tech: 'CITIZEN TECHNOLOGIES SITE',
        citizen: 'CITIZEN GLOBAL SITE',
        citizen_global: 'CITIZEN GLOBAL NETWORK',
        topics_reuters: 'Super Titanium™ and <br />the challenge of space',
        topics_citizen_global: 'CITIZEN GLOBAL <br />NETWORK',
        topics_product1: 'Ein halbes Jahrhundert Fortschritt.<br />Unbegrenzte Möglichkeiten.',
        topics_product2: 'CITIZEN Titan-Technologie<br />Limitiertes Modell zum 50-jährigen Jubiläum',
        topics_blue1: 'シチズン チタニウム<br />技術50周年記念',
        topics_blue2: 'コズミックブルー<br />コレクション',
        feature1: 'Strong. Beautiful. <br />Comfortable.',
        feature2: 'CITIZEN proprietary <br />titanium technologies',
        manufacture: 'Manufacture',
        supertitanium: 'Super Titanium™',
        reuters: 'Super Titanium™ and <br />the challenge of space',
      },
      nav: {
        language: [
          {
            name: 'GLOBAL',
            link: 'ENGLISH'
          },
          {
            name: 'JAPANESE',
            link: '日本語'
          },
          {
            name: 'TRADITIONAL <br class="u-none-b--sp">CHINESE',
            link: '繁體中文'
          },
          {
            name: 'SIMPLIFIED <br class="u-none-b--sp">CHINESE',
            link: '简体中文'
          },
          {
            name: 'GERMAN',
            link: 'DEUTSCH'
          },
          {
            name: 'ITALIAN',
            link: 'ITALIANO'
          },
          {
            name: 'SPANISH',
            link: 'ESPAÑOL'
          },
          {
            name: 'FRENCH',
            link: 'FRANÇAIS'
          }
        ]
      }
    },
    fr: {
      links: {
        title: '50th anniversary of <br />titanium technology',
        top: 'TOP PAGE',
        message: 'MESSAGE',
        about: 'ABOUT',
        features: 'FEATURES',
        special: 'SPECIAL',
        product: 'PRODUCT',
        contents: 'CONTENTS',
        language: 'LANGUAGE',
        official: 'OFFICIAL',
        share: 'SHARE',
        topics: 'TOPICS',
        page_top: 'TOP PAGE',
        page_benefit: 'FEATURE #01',
        page_technology: 'FEATURE #02',
        page_product: 'PRODUCT',
        citizen_tech: 'CITIZEN TECHNOLOGIES SITE',
        citizen: 'CITIZEN GLOBAL SITE',
        citizen_global: 'CITIZEN GLOBAL NETWORK',
        topics_reuters: 'Super Titanium™ and <br />the challenge of space',
        topics_citizen_global: 'CITIZEN GLOBAL <br />NETWORK',
        topics_product1: 'Un demi-siècle de progrès.<br />Une infinité de possibilités.',
        topics_product2: 'CITIZEN Titanium Technologie<br />Edition limitée 50e anniversaire',
        topics_blue1: 'シチズン チタニウム<br />技術50周年記念',
        topics_blue2: 'コズミックブルー<br />コレクション',
        feature1: 'Strong. Beautiful. <br />Comfortable.',
        feature2: 'CITIZEN proprietary <br />titanium technologies',
        manufacture: 'Manufacture',
        supertitanium: 'Super Titanium™',
        reuters: 'Super Titanium™ and <br />the challenge of space',
      },
      nav: {
        language: [
          {
            name: 'GLOBAL',
            link: 'ENGLISH'
          },
          {
            name: 'JAPANESE',
            link: '日本語'
          },
          {
            name: 'TRADITIONAL <br class="u-none-b--sp">CHINESE',
            link: '繁體中文'
          },
          {
            name: 'SIMPLIFIED <br class="u-none-b--sp">CHINESE',
            link: '简体中文'
          },
          {
            name: 'GERMAN',
            link: 'DEUTSCH'
          },
          {
            name: 'ITALIAN',
            link: 'ITALIANO'
          },
          {
            name: 'SPANISH',
            link: 'ESPAÑOL'
          },
          {
            name: 'FRENCH',
            link: 'FRANÇAIS'
          }
        ]
      }
    },
    it: {
      links: {
        title: 'Il 50. anniversario della nostra <br>tecnologia applicata al titanio',
        top: 'TOP PAGE',
        message: 'MESSAGGIO',
        about: 'I DETTAGLI',
        features: 'FEATURES',
        special: 'SPECIAL',
        product: 'PRODUCT',
        contents: 'CONTENTS',
        language: 'LANGUAGE',
        links: 'LINKS',
        official: 'OFFICIAL',
        share: 'SHARE',
        topics: 'TOPICS',
        page_top: 'TOP PAGE',
        page_benefit: 'FEATURE #01',
        page_technology: 'FEATURE #02',
        page_product: 'PRODUCT',
        citizen_tech: 'CITIZEN TECHNOLOGIES SITE',
        citizen: 'CITIZEN GLOBAL SITE',
        citizen_global: 'CITIZEN GLOBAL NETWORK',
        topics_reuters: 'Super Titanium™ and <br />the challenge of space',
        topics_citizen_global: 'CITIZEN GLOBAL <br />NETWORK',
        topics_product1: 'Mezzo secolo di progressi<br />Infinite possibilità',
        topics_product2: 'La tecnologia di CITIZEN applicata al titanio <br />Modello a edizione limitata dedicato al 50. <br />anniversario',
        topics_blue1: 'シチズン チタニウム<br />技術50周年記念',
        topics_blue2: 'コズミックブルー<br />コレクション',
        feature1: 'Strong. Beautiful. <br />Comfortable.',
        feature2: 'CITIZEN proprietary <br />titanium technologies',
        manufacture: 'Manufacture',
        supertitanium: 'Super Titanium™',
        reuters: 'Super Titanium™ and <br />the challenge of space',
      },
      nav: {
        language: [
          {
            name: 'GLOBAL',
            link: 'ENGLISH'
          },
          {
            name: 'JAPANESE',
            link: '日本語'
          },
          {
            name: 'TRADITIONAL <br class="u-none-b--sp">CHINESE',
            link: '繁體中文'
          },
          {
            name: 'SIMPLIFIED <br class="u-none-b--sp">CHINESE',
            link: '简体中文'
          },
          {
            name: 'GERMAN',
            link: 'DEUTSCH'
          },
          {
            name: 'ITALIAN',
            link: 'ITALIANO'
          },
          {
            name: 'SPANISH',
            link: 'ESPAÑOL'
          },
          {
            name: 'FRENCH',
            link: 'FRANÇAIS'
          }
        ]
      }
    },
    es: {
      links: {
        title: '50th anniversary of <br />titanium technology',
        top: 'TOP PAGE',
        message: 'MESSAGE',
        about: 'ABOUT',
        features: 'CARACTERÍSTICAS',
        special: 'SPECIAL',
        product: 'PRODUCT',
        contents: 'CONTENTS',
        language: 'LANGUAGE',
        links: 'LINKS',
        official: 'OFFICIAL',
        share: 'SHARE',
        topics: 'TOPICS',
        page_top: 'TOP PAGE',
        page_benefit: 'CARACTERÍSTICA #01',
        page_technology: 'CARACTERÍSTICA #02',
        page_product: 'PRODUCT',
        citizen_tech: 'CITIZEN TECHNOLOGIES SITE',
        citizen: 'CITIZEN GLOBAL SITE',
        citizen_global: 'CITIZEN GLOBAL NETWORK',
        topics_reuters: 'Super Titanium™ y <br />el reto del espacio',
        topics_citizen_global: 'CITIZEN GLOBAL <br />NETWORK',
        topics_product1: 'Medio siglo de progreso.<br />Una infinidad de posibilidades.',
        topics_product2: 'Tecnología CITIZEN en titanio<br />50th Anniversary Limited Model',
        topics_blue1: 'シチズン チタニウム<br />技術50周年記念',
        topics_blue2: 'コズミックブルー<br />コレクション',
        feature1: 'Strong. Beautiful. <br />Comfortable.',
        feature2: 'CITIZEN proprietary <br />titanium technologies',
        manufacture: 'Manufacture',
        supertitanium: 'Super Titanium™',
        reuters: 'Super Titanium™ y <br />el reto del espacio',
      },
      nav: {
        language: [
          {
            name: 'GLOBAL',
            link: 'ENGLISH'
          },
          {
            name: 'JAPANESE',
            link: '日本語'
          },
          {
            name: 'TRADITIONAL <br class="u-none-b--sp">CHINESE',
            link: '繁體中文'
          },
          {
            name: 'SIMPLIFIED <br class="u-none-b--sp">CHINESE',
            link: '简体中文'
          },
          {
            name: 'GERMAN',
            link: 'DEUTSCH'
          },
          {
            name: 'ITALIAN',
            link: 'ITALIANO'
          },
          {
            name: 'SPANISH',
            link: 'ESPAÑOL'
          },
          {
            name: 'FRENCH',
            link: 'FRANÇAIS'
          }
        ]
      }
    },
    "zh-cmn-Hant": {
      links: {
        title: '50th anniversary of <br />titanium technology',
        top: '首頁',
        message: '概要',
        about: '關於',
        features: '特性',
        special: '專題',
        product: '產品',
        contents: '目錄',
        language: '語言',
        links: '鏈結網站',
        official: '官方賬號',
        share: '分享',
        topics: '主題',
        page_top: '首頁',
        page_benefit: '特性 #01',
        page_technology: '特性 #02',
        page_product: '產品',
        citizen_tech: 'CITIZEN技術網站',
        citizen: 'CITIZEN全球官方網站',
        citizen_global: 'CITIZEN全球網絡',
        topics_reuters: '超級鈦™和太空挑戰',
        topics_citizen_global: 'CITIZEN全球網站',
        topics_product1: '半世紀的開拓創新<br />創造無限可能',
        topics_product2: 'CITIZEN超級鈦™技術<br />50周年限量型號',
        topics_blue1: 'シチズン チタニウム<br />技術50周年記念',
        topics_blue2: 'コズミックブルー<br />コレクション',
        feature1: 'Strong. Beautiful. <br />Comfortable.',
        feature2: 'CITIZEN proprietary <br />titanium technologies',
        manufacture: 'Manufacture',
        supertitanium: 'Super Titanium™',
        reuters: '超級鈦™和太空挑戰',
      },
      nav: {
        language: [
          {
            name: '英文',
            link: 'ENGLISH'
          },
          {
            name: '日文',
            link: '日本語'
          },
          {
            name: '繁體中文',
            link: '繁體中文'
          },
          {
            name: '簡體中文',
            link: '简体中文'
          },
          {
            name: '德文',
            link: 'DEUTSCH'
          },
          {
            name: '意大利文',
            link: 'ITALIANO'
          },
          {
            name: '西班牙文',
            link: 'ESPAÑOL'
          },
          {
            name: '法文',
            link: 'FRANÇAIS'
          }
        ]
      }
    },
    "zh-cmn-Hans": {
      links: {
        title: '50th anniversary of <br />titanium technology',
        top: '首页',
        message: '概要',
        about: '关于',
        features: '特性',
        special: '专题',
        product: '产品',
        contents: '目录',
        language: '语言',
        links: '链接',
        official: '官方账号',
        share: '分享',
        topics: '主题',
        page_top: '首页',
        page_benefit: '特性 #01',
        page_technology: '特性 #02',
        page_product: '产品',
        citizen_tech: '西铁城技术网站',
        citizen: '西铁城全球网站',
        citizen_global: '西铁城全球网点',
        topics_reuters: '舒博钛和太空挑战',
        topics_citizen_global: '西铁城全球网点',
        topics_product1: '半个世纪的开拓前行<br />创造无限可能',
        topics_product2: '西铁城舒博钛技术<br />五十周年限定款',
        topics_blue1: 'シチズン チタニウム<br />技術50周年記念',
        topics_blue2: 'コズミックブルー<br />コレクション',
        feature1: '强大、美观、舒适',
        feature2: '西铁城特有钛技术',
        manufacture: '匠心制造',
        supertitanium: '舒博钛',
        reuters: '舒博钛和太空挑战',
      },
      nav: {
        language: [
          {
            name: '英语',
            link: 'ENGLISH'
          },
          {
            name: '日语',
            link: '日本語'
          },
          {
            name: '繁體中文',
            link: '繁體中文'
          },
          {
            name: '简体中文',
            link: '简体中文'
          },
          {
            name: '德语',
            link: 'DEUTSCH'
          },
          {
            name: '意大利语',
            link: 'ITALIANO'
          },
          {
            name: '西班牙语',
            link: 'ESPAÑOL'
          },
          {
            name: '法语',
            link: 'FRANÇAIS'
          }
        ]
      }
    },
    global: {
      links: {
        title: '50th anniversary of <br />titanium technology',
        top: 'TOP PAGE',
        message: 'MESSAGE',
        about: 'ABOUT',
        features: 'FEATURES',
        special: 'SPECIAL',
        product: 'PRODUCT',
        contents: 'CONTENTS',
        language: 'LANGUAGE',
        official: 'OFFICIAL',
        share: 'SHARE',
        topics: 'TOPICS',
        page_top: 'TOP PAGE',
        page_benefit: 'FEATURE #01',
        page_technology: 'FEATURE #02',
        page_product: 'PRODUCT',
        citizen_tech: 'CITIZEN TECHNOLOGIES SITE',
        citizen: 'CITIZEN GLOBAL SITE',
        citizen_global: 'CITIZEN GLOBAL NETWORK',
        topics_reuters: 'Super Titanium™ and <br />the challenge of space',
        topics_citizen_global: 'CITIZEN GLOBAL <br />NETWORK',
        topics_product1: '50th Anniversary Flagship Model',
        topics_product2: 'SATELLITE WAVE GPS F950',
        topics_blue1: '',
        topics_blue2: '50th Anniversary<br />Limited Models',
        feature1: 'Strong. Beautiful. <br />Comfortable.',
        feature2: 'CITIZEN proprietary <br />titanium technologies',
        manufacture: 'Manufacture',
        supertitanium: 'Super Titanium™',
        reuters: 'Super Titanium™ and <br />the challenge of space',
      },
      nav: {
        language: [
          {
            name: 'GLOBAL',
            link: 'ENGLISH'
          },
          {
            name: 'JAPANESE',
            link: '日本語'
          },
          {
            name: 'TRADITIONAL <br class="u-none-b--sp">CHINESE',
            link: '繁體中文'
          },
          {
            name: 'SIMPLIFIED <br class="u-none-b--sp">CHINESE',
            link: '简体中文'
          },
          {
            name: 'GERMAN',
            link: 'DEUTSCH'
          },
          {
            name: 'ITALIAN',
            link: 'ITALIANO'
          },
          {
            name: 'SPANISH',
            link: 'ESPAÑOL'
          },
          {
            name: 'FRENCH',
            link: 'FRANÇAIS'
          }
        ]
      }
    }
  }
};

const mutations = {
  setLang(state) {
    const lang = document.getElementsByTagName('html')[0].getAttribute('lang');
    state.lang = lang;
    if (lang === 'ja') {
      state.links = state.urls['ja'];
      state.note = state.notes['ja'];
    } else if (lang === 'en') {
      state.links = state.urls['en'];
      state.note = state.notes['global'];
    } else if (lang === 'de') {
      state.links = state.urls['de'];
      state.note = state.notes['de'];
    } else if (lang === 'es') {
      state.links = state.urls['es'];
      state.note = state.notes['es'];
    } else if (lang === 'fr') {
      state.links = state.urls['fr'];
      state.note = state.notes['fr'];
    } else if (lang === 'it') {
      state.links = state.urls['it'];
      state.note = state.notes['it'];
    } else if (lang === 'zh-cmn-Hant') {
      state.links = state.urls['zh-cmn-Hant'];
      state.note = state.notes['zh-cmn-Hant'];
    } else if (lang === 'zh-cmn-Hans') {
      state.links = state.urls['zh-cmn-Hans'];
      state.note = state.notes['zh-cmn-Hans'];
    } else {
      state.links = state.urls['global'];
      state.note = state.notes['global'];
    }
  },
  setShowGnav(state, isShow) {
    state.isShowGnav = isShow;
  },
  setShowLinks(state, isShow) {
    state.isShowLinks = isShow;
  },
  setUA(state) {
    if (!state.ua) {
      const parser = new UAParser();
      const ua = parser.getResult();
      state.ua = ua;
    }
  }
};

const getters = {
  getLang: (state) => {
    return state.lang;
  },
  isShowGnav: (state) => {
    return state.isShowGnav;
  },
  isShowLinks: (state) => {
    return state.isShowLinks;
  },
  getUrls: (state) => {
    return state.links;
  },
  getNote: (state) => {
    return state.note;
  },
  getUA: (state) => {
    return state.ua;
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations
});